<template>
  <div>
    <CategoryListFilters />

    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="categories"
        :loading="isLoading"
        :no-data-text="$t('table.noResults')"
        :loading-text="$t('table.loading')"
        :items-per-page="itemsPerPage"
        mobile-breakpoint="20"
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex">
            <v-btn @click="handleOpenCreateCategoryModal(item.id)" icon small>
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-spacer class="mx-1" />
            <v-btn @click="handleDeleteCategoryModal(item.id)" icon small>
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchCategories" />

    <CategoryDelete />
    <CategoryCreateEdit ref="createCategory" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { categoriesHeader } from '@/views/category/listHeaders'

import CategoryDelete from './category/components/CategoryDelete'
import CategoryCreateEdit from './category/components/CategoryCreateEdit'
import CategoryListFilters from './category/components/CategoryListFilters'

export default {
  name: 'CategoryList',

  components: {
    CategoryDelete,
    CategoryCreateEdit,
    CategoryListFilters,
  },

  data() {
    return {
      headers: categoriesHeader,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'categories', 'itemsPerPage']),
  },

  methods: {
    ...mapMutations(['callModal']),
    ...mapActions(['fetchCategories', 'handleDeleteCategoryModal', 'handleOpenCreateCategoryModal']),
  },

  mounted() {
    this.fetchCategories()
  },
}
</script>
